<template>
  <v-dialog
    v-model="show"
    width="500"
  >
    <v-card>

      <v-card-title class="justify-center">
        <span class="text-h5">Просмотр уведомления</span>

        <v-spacer />

        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider class="mb-5" />

      <v-card-text style="position: relative;">
        <p class="h5 pb-0">{{ notification.title }}</p>
        <span class="text">{{ notification.created_at }}</span>

        <div class="my-3" v-html="notification.content"></div>

        <v-overlay :value="loading" absolute>
          <v-progress-circular indeterminate color="green" />
        </v-overlay>
      </v-card-text>

    </v-card>

  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'NotificationView',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
    },
  },

  data() {
    return {
      loading: true,
      notification: {
        id: null,
        title: null,
        content: null,
        viewed: null,
        created_at: null,
      },
    }
  },

  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },

  watch: {
    show(val) {
      if (val) {
        this.loadNotification()
      } else {
        for (const key in this.notification) {
          this.notification[key] = null
        }
      }
    },
  },

  methods: {
    ...mapActions({
      getNotification: 'notifications/getNotification',
    }),

    loadNotification() {
      this.loading = true

      this.getNotification(this.id)
        .then(resp => {
          console.log('notification', resp)
          this.notification = resp.data
        }).finally(() => {
          this.loading = false
        })
    },
  },

}
</script>

<style>

</style>
